import { useProductOutput } from "stores/product";
import { InputCard } from "components/InputCards/InputCard";
import React from "react";
import { useResultingListForm } from "../providers/ResultingListProvider";

import cx from "classnames";

export const ResultingListProperties = () => {
  const productOutput = useProductOutput();
  const listViewConfiguration = productOutput?.product?.listViewConfiguration;
  const { values, setValue } = useResultingListForm();

  if (!listViewConfiguration?.targetProperties) {
    return null;
  }

  return (
    <div className="pt-4">
      {listViewConfiguration.targetPropertiesTitle && (
        <h5 className="mb-2 font16">
          {listViewConfiguration.targetPropertiesTitle}
        </h5>
      )}
      <div className="row">
        {listViewConfiguration?.targetProperties?.map(
          (property, index: number) =>
            property !== null ? (
              <div
                key={property.id}
                className={cx("col-12 col-lg-6", {
                  "border-lg-end": index % 2 === 0,
                })}
              >
                <InputCard
                  key={property.id}
                  label={property.name}
                  defaultValue={property.defaultValue ?? 0}
                  value={
                    (values[property.id] ??
                      property.defaultValue ??
                      0) as number
                  }
                  displayValue={String(property.defaultValue ?? "")}
                  valueMin={property.valueMin ?? 0}
                  valueMax={property.valueMax ?? 0}
                  unit={property.unit}
                  isValueEditable={true}
                  onChange={(val) =>
                    setValue(
                      property.id,
                      typeof val === "object"
                        ? val.changeInput.inputValue
                        : val,
                    )
                  }
                  testId={`${property.id}`}
                  subLabel={
                    !!(property.valueMin && property.valueMax) &&
                    `${property.valueMin}..${property.valueMax} ${property.unit}`
                  }
                  validationMessage={""}
                  validationType={0}
                />
              </div>
            ) : (
              <></>
            ),
        )}
      </div>
    </div>
  );
};
